// The search bar is one line: whitespace collapses to single spaces, except
// inside quoted literals and identifiers, whose spacing is part of the value.
export function sqlOneLine(sql: string): string {
  return sql
    .replace(/('(?:[^']|'')*'|"(?:[^"]|"")*")|\s+/g, (_, quoted) =>
      quoted ? quoted : " "
    )
    .trim();
}
